import React from "react";
import styled from "styled-components";
import { motion } from "motion/react";
import { VideoFrame } from "../types";

const TopLayerContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: 20px;
  width: 100%;
  gap: 4px;
`;

const Title = styled(motion.h2)`
  color: #f7f8f8;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
`;

const Description = styled(motion.p)`
  color: #8a8f98;
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 11px;
`;

interface TopLayerProps {
  currentVideo: VideoFrame;
  isTransitioning: boolean;
}

export default function TopLayer({ currentVideo, isTransitioning }: TopLayerProps) {
  return (
    <TopLayerContainer>
      <Title animate={{ opacity: isTransitioning ? 0 : 1 }} transition={{ duration: 0.5 }}>
        {currentVideo?.title}
      </Title>
      <Description animate={{ opacity: isTransitioning ? 0 : 1 }} transition={{ duration: 0.5 }}>
        {currentVideo?.description}
      </Description>
    </TopLayerContainer>
  );
}